<template>
    <div class="setting-online-lineup">
        <div class="module-item-style">
            <div class="module-item-title chat-overtime-title">
                <div>
                    访客排队
                </div>
                <div class="online-base-switch-btn">
                    <el-switch
                            v-model="lineupBtn"
                            @change="lineupStatus(lineupBtn)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="chat-overtime-tips">
                当客服服务达到上限时，顾客会进入排队等待状态，同时可以进行留言
            </div>
        </div>
        <div class="module-item-style" v-if="lineupBtn">
            <div class="module-item-title chat-overtime-title">
                提示文案
            </div>
            <div class="chat-overtime-content" style="margin-top: 10px;">
                <el-input
                        class="input-textarea"
                        type="textarea"
                        resize="none"
                        rows="4"
                        maxlength="250"
                        show-word-limit
                        @blur="saveChange('remark',postData.remark)"
                        placeholder="请输入内容..."
                        v-model="postData.remark">
                </el-input>
            </div>
        </div>
        <div class="module-item-style" v-if="lineupBtn">
            <div class="module-item-title chat-overtime-title">
                排队上限
            </div>
            <div class="chat-overtime-tips">
                取值范围【1～2000】
            </div>
            <div class="chat-overtime-content">
                <div class="chat-finish-time-set">
                    当排队人数超过 <input min="1" max="2000" class="chat-finish-num" v-model="postData.value" @change="saveChange('value',postData.value)" type="number"> 人时，后续新进入对话自动转到留言
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "setting-online-lineup",
        data() {
            return {
                lineupBtn: false,
                postData:{
                    value: 0,
                    remark:''
                }
            }
        },
        created() {
            this.initLineup()
            this.getLineupStatus()
        },
        mounted() {
        },
        methods: {
            initLineup(){
                this.$http.getLineupSwitchAPI().then( res => {
                    console.log(res)
                    if (res.status == 1) {
                        this.postData.value = res.data.configValue
                        this.postData.remark = res.data.configRemark
                    }
                })
            },
            getLineupStatus () {
                this.$http.selectQueuesWitchAPI().then(res => {
                    if(res.status == 1){
                        if (res.data.configValue == '0') {
                            this.lineupBtn = false
                        } else if (res.data.configValue == '1') {
                            this.lineupBtn = true
                        }
                    }
                })
            },
            lineupStatus(val){
                let postData = {
                    value: val ? '1' : '0'
                }
                this.$http.saveQueuesWitchAPI(postData).then(res => {
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                    this.getLineupStatus()

                })

            },
            saveChange(name,value){
                if (this.postData.value.length === 0){

                    this.postData.value = '1'
                    this.$message({
                        message: '请输入1～2000之间的数字！',
                        type: 'error',
                    })
                    return false
                } else {
                    if(this.postData.value > 2000) {
                        this.postData.value = '2000'
                        this.$message({
                            message: '请输入1～2000之间的数字！',
                            type: 'error',
                        })
                        return false
                    }
                }
                if (this.postData.remark.trim().length === 0) {
                    this.$message({
                        message: '提示文案不能为空！',
                        type: 'error',
                    })
                    return false
                }
                this.$http.lineupSwitchChangeAPI(this.postData).then( res => {
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                        this.initLineup()
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            }
        },
    }
</script>

<style lang="scss">
    .setting-online-lineup {
        .chat-overtime-title {
            display: flex;
            .online-base-switch-btn {
                margin-left: auto;
            }
        }

        .chat-overtime-tips {
            color: #999;
            font-size: 12px;
            padding: 12px 0 15px 0;
        }

        .chat-overtime-content {
            .input-textarea {
                width: 600px;
            }
            .chat-finish-time-set{
                color: #666;
                padding: 10px 0 20px;
                font-size: 12px;
            }
            .chat-finish-num{
                width:60px;
                height:40px;
                background:rgba(255,255,255,1);
                border:1px solid rgba(238,238,238,1);
                border-radius:4px;
                outline: none;
                padding: 5px;
                text-align: center;
                margin: 0 5px;
            }
        }
    }
</style>